import { render, staticRenderFns } from "./NewInfoCard.vue?vue&type=template&id=79522da0&"
import script from "./NewInfoCard.vue?vue&type=script&lang=js&"
export * from "./NewInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports